export default __webpack_public_path__ + "static/media/Narangi.73d5bee9.png";